import { _,moment } from '../../../vendor'
import { Notification,Biscuit } from '../../utils'
import InboomaBaseView from '../InboomaBaseView'
import InboomaBaseCollectionView from '../InboomaBaseCollectionView'

import PaginationBehavior from '../../behaviors/Behavior.Pagination'

import UsersItemCustomersTpl from '../../templates/users/UsersItemCustomersTpl.html'

const UsersItemCustomersView = InboomaBaseView.extend({

  template : UsersItemCustomersTpl,
  className : 'inb-c-item-details-row inb-c-item--user-clients row',

  ui : {
    removeUser: '.inb-user-remove',
    userActiveSwitch: '.user-active-switch'
  },

  templateContext () {
    return {
      moment
    }
  },

  events : {
    'click @ui.removeUser' : '_removeUser',
    'click @ui.userActiveSwitch' : '_changeUserActiveState'
  },

  onRender () {
    this.$el.attr('title', );
  },

  _stateChangeInProgress : false,

  _changeUserActiveState () {
    // ev.preventDefault() would dismiss the CSS-animation,
    // we therefore check for running requests locally
    // using this._stateChangInProgress

    if (this._stateChangeInProgress) return;

    this._stateChangeInProgress = true;
    
    const that = this,
          newActiveState = this.model.get('active') ? false : true;
          // for some reason ... = !!this.model.get('active')
          // was not working :( #noJsMagicTodayBuddy

    this.model.save({ active: newActiveState }, {
      patch: true,
      success () {

        that._stateChangeInProgress = false;

        new Notification({
          message: that.t('user_state_updated'),
          duration: 5000,
          closeable: true,
          icon: 'fi fi-torso'
        });

        that.render();
      }
    })
  },

  _removeUser (ev) {

    ev.preventDefault();

    const that = this;

    let rights = {
        'user': 0,
        'manager': 1,
        'booking-manager': 1,
        'admin': 2
    }

    const role = Biscuit.get('user.role'),
          targetRole = this.model.get('role');

    if (rights[role] > rights[targetRole]) {
        if (confirm(this.t('really_remove'))) {
            this.model.destroy({
                success: function (model, repsonse) {

                    that.$el.fadeOut('fast');
                    new Notification({
                        message: that.t('removed_${a}', {a: that.t('customer')}, 'capital'),
                        duration: 5000,
                        closeable: true,
                        icon: 'fi fi-trash'
                    });

                }
            });
        }

    } else {
        that.$el.fadeOut('fast');
        new Notification({
            message: that.t('cannot_remove_${a}', {a: that.t('customer')}, 'capital'),
            duration: 5000,
            closeable: true,
            icon: 'fi fi-trash'
        });
    }

  },

});

export default InboomaBaseCollectionView.extend({

  childView: UsersItemCustomersView,
  template: _.noop,

  behaviors : [
    {
      behaviorClass: PaginationBehavior
    }
  ],

  initialize () {

    //this.collection.filterByRole(['user']);
    InboomaBaseCollectionView.prototype.initialize.apply(this);
    this.hasNextPageListener = false;
    this.$el.html('');
    this.render();
    this.listenTo(this.collection, "add", this.onChangeChildView,this);
    this.listenTo(this.collection, "remove", this.onChangeChildView,this);
    //$('#customer-badge').html(this.collection.length);

  },

  onChangeChildView (model,collection,options) {

    const that = this;

    setTimeout(function () {                                                                              // timer is necessary to ensure that pagination has the correct value
      if (that.collection.length < that.collection._pagination.count) {
        var nextBtn = document.getElementsByClassName('inb-next-page-button')[0];
        if (typeof nextBtn !== 'undefined') nextBtn.className = 'inb-next-page-button button';
      }
      else {
        var nextBtn = document.getElementsByClassName('inb-next-page-button')[0];
        if (typeof nextBtn !== 'undefined') nextBtn.className = 'inb-next-page-button button hide';
      }
    },200);
  },

  onRender () {

    if (!this.hasNextPageListener) {

      const that = this;
      var nextBtn = document.getElementsByClassName('inb-next-page-button')[0];

      nextBtn.addEventListener("click",function () {
        if (document.location.href.indexOf('users/staff') >= 0) return;
        if (document.location.href.indexOf('users') < 0) return;
        that.collection.fetchNextPage();
      });
      this.hasNextPageListener = true;
    }
  }

});
